import AbstractType from "./AbstractType";

export default class StringType extends AbstractType
{
    static type = "string";

    test = (value) => typeof value === "string";

};